import { Middleware } from '@nuxt/types'

import { isSitecoreRequest } from '~/utils/isSitecoreRequest'
import { getOptions } from '~/utils/getOptions'
import { getMembershipTier } from '~/utils/getMembershipTier'
import { MEMBERSHIP_TIERS } from '~/constants/MembershipTiers';

const userPermissions: Middleware = async ({ store, req, route, error }) => {
  if (isSitecoreRequest(req)) {
    return
  }

  const { currentUser } = store.getters
  const membershipTier = currentUser ? getMembershipTier(currentUser) : MEMBERSHIP_TIERS.PUBLIC
 
  // Get permissions linked to each page
  const permissionRestrictions = getOptions(route, 'allowedPermissionsTiers')
  
  // By default, pages are restricted
  if (!permissionRestrictions.length) {
    return error({ statusCode: 403 })
  }

  // If the subscriptionType of the user does not exists in the restictions array, we block them
  if (!permissionRestrictions.includes(membershipTier)) {
    return error({ statusCode: 403 })
  }
}

export default userPermissions
